export const Jobs = [
    {
        type: "Jobs and Entrepreneurship",
        name: "Vegpreneur",
        category: "",
        author: "",
        description: "",
        link: "https://www.vegpreneur.org/jobs",
        "": "",
    },
    {
        type: "Jobs and Entrepreneurship",
        name: "Vegan Jobs",
        category: "",
        author: "",
        description: "",
        link: "https://veganjobs.com/",
        "": "",
    },
    {
        type: "Jobs and Entrepreneurship",
        name: "Animal Advocacy Careers",
        category: "",
        author: "",
        description: "",
        link: "https://www.animaladvocacycareers.org/job-board",
        "": "",
    },
    {
        type: "Jobs and Entrepreneurship",
        name: "PETA Jobs",
        category: "",
        author: "",
        description: "",
        link: "https://www.peta.org/about-peta/work-at-peta/search-jobs-peta/",
        "": "",
    },
    {
        type: "Jobs and Entrepreneurship",
        name: "Beyond Animal",
        category: "",
        author: "",
        description: "",
        link: "https://beyondanimal.com/job/list",
        "": "",
    },
    {
        type: "Jobs and Entrepreneurship",
        name: "The Humane Leauge",
        category: "",
        author: "",
        description: "",
        link: "https://thehumaneleague.org/single-offer-career?gh_jid=3788061",
        "": "",
    },
    {
        type: "Jobs and Entrepreneurship",
        name: "VegNews Jobs",
        category: "",
        author: "",
        description: "",
        link: "https://vegnews.com/jobs",
        "": "",
    },
]
